import React from 'react'
import QRCode from 'qrcode.react'

// just a wrapper for now until we decide to customize it some
const QRCodeWrapper = props => <QRCode {...props} />

export default QRCodeWrapper
